import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const Userinfo = ({ data, onSave }) => {
  const updateData = (field, value) => {
    onSave("userinfo", { ...data, [field]: value });
  };

  return (
    <>
      <section className="userInfoSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>5. Your Information</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 skillForm">
              <form>
                <div className="form-group mb-4">
                  <label htmlFor="name">What's Your Full Name?</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    name="name"
                    placeholder="Full Name"
                    onChange={(e) => updateData("name", e.target.value)}
                    value={data.name}
                  />
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="email">What's Your Email ID?</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    name="email"
                    placeholder="Email ID"
                    onChange={(e) => updateData("email", e.target.value)}
                    value={data.email}
                  />
                </div>

                <div className="form-group mb-4">
                  <label htmlFor="number">What's Your Phone Number?</label>
                  <PhoneInput
                    country={"us"}
                    enableSearch={true}
                    value={data.number}
                    placeholder="+1 (123) 456-7890"
                    onChange={(e) => updateData("number", e)}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Userinfo;
